module.exports = __webpack_public_path__ + "static/media/default_profile.d224a565.svg";